import { eventModal } from "@NextSkyTheme/modal";

class FloatingOfferButton extends HTMLElement {
  connectedCallback() {
    this.storageKey =
      this.dataset.storageKey ||
      "floating-offer-dismissed-" + (this.dataset.sectionId || "default");

    if (this.isDismissed()) {
      this.remove();
      return;
    }

    this.trigger = this.querySelector(".floating-offer__trigger");
    this.closeButton = this.querySelector(".floating-offer__close");
    this.modal = this.querySelector(".floating-offer-modal");
    // Note: the modal's own close button uses the native `is="button-close-model"`
    // behavior to close the modal and intentionally has no extra listener here —
    // closing the modal must never dismiss the floating button for the session.
    // Only `.floating-offer__close` (the X on the floating button itself) does that.

    if (this.trigger) {
      this.trigger.addEventListener("click", this.openModal.bind(this));
    }

    if (this.closeButton) {
      this.closeButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.dismiss();
      });
    }

    this.setupScrollReveal();
  }

  setupScrollReveal() {
    if (this.dataset.showAfterScroll !== "true") return;

    const threshold = parseInt(this.dataset.showAfterScrollOffset, 10) || 0;

    const reveal = () => {
      if (window.scrollY <= threshold) return false;
      this.classList.remove("is-pending-scroll");
      window.removeEventListener("scroll", onScroll);
      return true;
    };

    const onScroll = () => reveal();

    // In case the page loads already scrolled past the threshold (anchor
    // links, restored scroll position, etc.), don't wait for a scroll event.
    if (!reveal()) {
      window.addEventListener("scroll", onScroll, { passive: true });
    }
  }

  openModal(event) {
    if (event.target.closest(".floating-offer__close")) return;
    if (!this.modal) return;
    eventModal(this.modal, "open", false);
  }

  isDismissed() {
    try {
      return window.localStorage.getItem(this.storageKey) === "true";
    } catch (error) {
      return false;
    }
  }

  dismiss() {
    try {
      window.localStorage.setItem(this.storageKey, "true");
    } catch (error) {
      /* localStorage unavailable (private browsing, storage disabled, etc.) */
    }

    if (this.modal && this.modal.classList.contains("active")) {
      eventModal(this.modal, "close", false);
    }

    this.classList.add("is-hidden");
    window.setTimeout(() => this.remove(), 300);
  }
}

if (!customElements.get("floating-offer-button")) {
  customElements.define("floating-offer-button", FloatingOfferButton);
}
